/* lystia-qty.js - кастомний елемент <lystia-qty> (T-E2-18, L.ui.qty). Розмітка - snippets/qty.liquid.
   Подія: 'lystia-qty:change' (bubbles) detail {value, prev}. API: setValue(n), setState(s), .value. */
if (!customElements.get('lystia-qty')) {
  class LystiaQty extends HTMLElement {
    connectedCallback() {
      this.minus = this.querySelector('[data-qty-minus]');
      this.plus = this.querySelector('[data-qty-plus]');
      this.out = this.querySelector('.qty__val');
      this.field = this.querySelector('input[type="hidden"]');
      this.min = this.num(this.dataset.min, 1);
      this.max = this.num(this.dataset.max, 99);
      this.current = this.num(this.dataset.value, this.min);
      if (this.minus) this.minus.addEventListener('click', () => this.step(-1));
      if (this.plus) this.plus.addEventListener('click', () => this.step(1));
      this.sync();
    }

    num(v, def) {
      const n = parseInt(v, 10);
      return Number.isNaN(n) ? def : n;
    }

    get value() {
      return this.current;
    }

    step(d) {
      const next = Math.max(this.min, Math.min(this.max, this.current + d));
      if (next === this.current) return;
      const prev = this.current;
      this.current = next;
      this.sync();
      if (next === this.max && this.dataset.maxText && document.lystiaToast) document.lystiaToast.show(this.dataset.maxText, {});
      this.dispatchEvent(new CustomEvent('lystia-qty:change', { bubbles: true, detail: { value: next, prev } }));
    }

    setValue(n) {
      this.current = n;
      this.sync();
    }

    setState(s) {
      this.classList.remove('is-loading', 'is-error');
      if (s && s !== 'default') this.classList.add('is-' + s);
      this.toggleAttribute('aria-busy', s === 'loading');
    }

    sync() {
      if (this.out) this.out.textContent = String(this.current);
      if (this.field) this.field.value = String(this.current);
      if (this.minus) this.minus.disabled = this.current <= this.min;
      if (this.plus) this.plus.disabled = this.current >= this.max;
    }
  }
  customElements.define('lystia-qty', LystiaQty);
}
